import { render, staticRenderFns } from "./BDXStatusModalDownloadButton.vue?vue&type=template&id=4bb874ac"
import script from "./BDXStatusModalDownloadButton.vue?vue&type=script&lang=js"
export * from "./BDXStatusModalDownloadButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports